/**
 * @prop --cursor: Cursor shown when users hovers over grabbable elements
 * @prop --grabbing-cursor: Cursor shown when item is grabbing
 * @prop --unselected-item-opacity: Opacity that none selected items get when one item has been selected with space bar
 * @prop --ghost-item-background: Background color of ghost item that is dragged around
 * @prop --ghost-item-box-shadow: Box shadow of ghost item that is dragged around
 */

:host {
  --cursor: grab;
  --grabbing-cursor: grabbing;
  --unselected-item-opacity: 0.6;
  --ghost-item-background: #{$colorGrey30};
  // --ghost-item-box-shadow: inset 0px 0px 8px rgba(0, 0, 0, 0.32);
  --ghost-item-box-shadow: none;

  &[disabled] {
    --cursor: inherit;
  }

  &[disabled] ::slotted(*) {
    *.is-sortable-item {
      user-select: auto;
    }
  }

  ::slotted(*) {
    *.is-sortable-item {
      position: relative;
      transition: opacity $baseTransitionAnimationSpeed;
      user-select: none;
      cursor: var(--cursor);

      &.is-drag,
      &.is-chosen,
      &.is-ghost,
      &.is-selected {
        cursor: var(--grabbing-cursor);
      }

      &.is-drag {
        opacity: 1 !important;
      }

      &.is-ghost {
        z-index: 0;
      }

      &.is-ghost::after {
        z-index: 99;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: var(--ghost-item-background);
        box-shadow: var(--ghost-item-box-shadow);
      }
    }

    &.has-item-selected > *.is-sortable-item {
      opacity: var(--unselected-item-opacity);

      &.is-selected {
        opacity: 1;
      }
    }
  }
}

.stzh-sortable {
  &__description,
  &__aria-live {
    @include visuallyhidden;
  }
}
